import {RouteContext} from 'modules/router/context';
import React, {FC, useContext} from 'react';

export const Outlet: FC = () => {
    const {component} = useContext(RouteContext);

    return <>{component}</>;
};
